<!--Forgot Password Starts-->
<section id="reset-password-screen">

  <form (keydown)="EnterKeyTrigger($event)" [formGroup]="ResetPasswordForm">


    <div class="container-fluid reset-password-screen-bg">
      <div class="row full-height-vh m-0  d-flex align-items-center justify-content-center">
        <div class="col-md-6 col-sm-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body fg-image">
                <div class="row m-0">

                  <div class="col-lg-12 col-md-12 bg-white px-4 pt-3">
                    <h4 class="card-title mb-2">
                      <span class="app-label-icon pr-1"><i class="fa-solid fa-user-lock"></i></span>
                      <span> {{ 'app.trn-reset-password' | translate }}</span>
                    </h4>
                    <p class="card-text mb-3">{{ 'app.trn-reset-title-message' | translate }}
                    </p>

                    <div>
                      <mat-form-field>
                        <mat-label>
                          <span class="app-label-icon pr-1"><i class="fa-solid fa-key"></i></span>
                          <span>{{ 'app.trn-old-password' | translate }}</span>
                        </mat-label>
                        <input matInput [type]="HiddenOldPassword ? 'password' : 'text'" formControlName="OldPassword">
                        <mat-icon class="cursor-pointer" matSuffix (click)="HiddenOldPassword = !HiddenOldPassword">
                          {{HiddenOldPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                        <mat-error class="tc-warn"
                          *ngIf="ResetPasswordForm.get('OldPassword').hasError('required') && ResetPasswordForm.get('OldPassword').touched">
                          <span>{{ 'app.trn-old-password-required' | translate }}</span>
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="pt-1 pb-1">
                      <mat-form-field>
                        <mat-label>
                          <span class="app-label-icon pr-1"><i class="fa-solid fa-key"></i></span>
                          <span>{{ 'app.trn-new-password' | translate }}</span>
                        </mat-label>
                        <input matInput [type]="HiddenNewPassword ? 'password' : 'text'" formControlName="NewPassword">
                        <mat-icon class="cursor-pointer" matSuffix (click)="HiddenNewPassword = !HiddenNewPassword">
                          {{HiddenNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                        <mat-error class="tc-warn"
                          *ngIf="ResetPasswordForm.get('NewPassword').hasError('required') && ResetPasswordForm.get('NewPassword').touched">
                          <span>{{ 'app.trn-new-password-required' | translate }}</span>
                        </mat-error>
                        <mat-error class="tc-warn"
                          *ngIf="ResetPasswordForm.get('NewPassword').hasError('NoPasswordComplexity') && !ResetPasswordForm.get('NewPassword').hasError('required')">
                          <span>{{ 'app.trn-new-password-complexity' | translate }}</span>
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="fg-actions d-flex justify-content-between pt-2 pb-2">

                      <div class="recover-pass">
                        <button (click)="ProcessResetPassword()" class="btn btn-primary">
                          <a class="text-decoration-none text-white">{{ 'app.trn-reset-password' | translate }}
                          </a>
                        </button>
                      </div>

                      <div class="other-btn">
                        <button (click)="goToLogin()" class="btn btn-outline-primary">
                          <a class="text-decoration-none">{{ 'app.trn-back-to-login' | translate }}</a>
                        </button>
                      </div>

                    </div>

                    <mat-progress-bar *ngIf='isLoading' mode="query"></mat-progress-bar>

                    <!-- <div class="d-flex justify-content-between mt-2 mb-2">
                      <div class="recover-pass">
                        <button (click)="goToLogin()" class="btn btn-outline-primary">
                          <a class="text-decoration-none">{{ 'app.trn-back-to-login' | translate }}</a>
                        </button>
                      </div>

                    </div> -->


                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
<!--Forgot Password Ends-->